import { z } from "zod"
import { UpdateGroupMemberDtoSchema } from "@mimber/schema"

/**
 * Form schema for updating a group member
 */
export const updateGroupMemberSchema = UpdateGroupMemberDtoSchema.extend({
  title: z
    .string()
    .max(255, "Title must be less than 255 characters")
    .optional()
    .or(z.literal(""))
    .transform((val) => (val === "" ? undefined : val)),
})

/**
 * Output type - this is what gets passed to onSubmit
 */
export type UpdateGroupMemberData = z.output<typeof updateGroupMemberSchema>
